import * as T from "../types";

export const createConfigFromApi = (response: T.RadioStartupApiResponse): T.AppConfig => {
  return {
    channels: Object.assign({}, ...response.channels.map((channel) => ({ [channel.id]: { name: channel.name } }))),
    categories: Object.assign({}, ...response.keywordCategories.map((category) => ({ [category.id]: category })))
  };
};

export const createRGBA = (highlight: T.HighlightApiResponse): string => {
  return `rgba(${highlight.r}, ${highlight.g}, ${highlight.b}, ${highlight.a})`;
};
